import React from "react";

import { Highlight } from "pages/admin/verifications/components/changeEvents/Highlight";
import { familyClass } from "pages/admin/verifications/utils/changeEventTimeline";

type ChangeEventTypeBadgeProps = {
  type: string;
  count?: number;
  query?: string;
  onClick?: () => void;
};

/**
 * The literal event type is always the information; the family colour only tints the border, because
 * most of the palette fails 3:1 contrast as text.
 */
export const ChangeEventTypeBadge = ({ type, count, query, onClick }: ChangeEventTypeBadgeProps) => {
  const className = `ce-badge ${familyClass(type)}`;
  const body = (
    <>
      <Highlight text={type} query={query} />
      {count === undefined ? null : <i>{count}</i>}
    </>
  );

  if (!onClick) return <span className={className}>{body}</span>;

  return (
    <button type="button" className={`${className} clickable`} onClick={onClick}>
      {body}
    </button>
  );
};
